module.exports = __webpack_public_path__ + "img/Orbiting-3-mobile.8e088c80.png";